var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","clipped-left":"","color":"#ECFD90","elevation":"0"}},[_c('img',{attrs:{"alt":"Equator Logo","src":require("../images/logo.png"),"height":"35"}})]),_c('v-main',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }